// 供应商
<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="采购单管理">
        <span slot="label"><i class="iconfont icon-purchase-manage" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_purch_order")}}</span>
        <GuestVendOrder></GuestVendOrder>
      </el-tab-pane>
      <el-tab-pane label="采购查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_purch_order_search")}}</span>
        <GuestVendPurchSearch></GuestVendPurchSearch>
      </el-tab-pane>
      <el-tab-pane label="预测订单">
        <span slot="label"><i class="iconfont icon-purchase-manage" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_forecast_order")}}</span>
        <GuestVendForcasetOrder></GuestVendForcasetOrder>
      </el-tab-pane>
      <el-tab-pane label="预测交货计划">
        <span slot="label"><i class="iconfont icon-purchase-manage" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_fo_delivery_plan")}}</span>
        <GuestVendSFDDeliveryPlan></GuestVendSFDDeliveryPlan>
      </el-tab-pane>
      <el-tab-pane label="产能导入">
        <span slot="label"><i class="iconfont icon-capacity" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_capacity_import")}}</span>
        <GuestVendProductionCapacity :is_pub="true"></GuestVendProductionCapacity>
      </el-tab-pane>
      <el-tab-pane label="产能查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_capacity_search")}}</span>
        <GuestVendProductionCapacitySearch></GuestVendProductionCapacitySearch>
      </el-tab-pane>
      <el-tab-pane label="库存导入">
        <span slot="label"><i class="iconfont icon-inventory" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_inventory_import")}}</span>
        <GuestVendInventSum :export_type="'vend'" :is_pub="true"></GuestVendInventSum>
      </el-tab-pane>
      <el-tab-pane label="库存导入查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_inventory_import_search")}}</span>
        <GuestVendInventSumSearch></GuestVendInventSumSearch>
      </el-tab-pane>
      <el-tab-pane label="询价申请单管理">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_guest_consult_handle")}}</span>
        <GuestVendConsultHandle></GuestVendConsultHandle>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import GuestVendOrder from "./GuestVendOrder";
import GuestVendForcasetOrder from "./GuestVendForcasetOrder";
import GuestVendPurchSearch from "./GuestVendPurchSearch";
import GuestVendProductionCapacity from "../fi/ProductionCapacityExport"
import GuestVendProductionCapacitySearch from "./GuestVendProductionCapacitySearch"
import GuestVendInventSumSearch from "./GuestVendInventSumSearch"
import GuestVendSFDDeliveryPlan from "./GuestVendSFDDeliveryPlan"
import GuestVendInventSum from "../wm/InventSumExport";
import GuestVendConsultHandle from "./GuestVendConsultHandle";

export default {
  name: "GuestVendMain",
  components: {
    GuestVendOrder,
    GuestVendForcasetOrder,
    GuestVendPurchSearch,
    GuestVendProductionCapacity,
    GuestVendInventSum,
    GuestVendProductionCapacitySearch,
    GuestVendInventSumSearch,
    GuestVendSFDDeliveryPlan,
    GuestVendConsultHandle,
  },
  data() {
    return {
      tab_index: 0
    };
  },
};
</script>


